import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { checkStoreState, setInitialStoreState } from '../../../../../../common/utils';
import { FailedMessagesProfileItemBriefFacade } from './failed-messages-profile-item-brief.facade';

@Injectable({ providedIn: 'root' })
export class FailedMessagesProfileItemBriefGuard {
  constructor(private failedMessagesProfileItemBriefFacade: FailedMessagesProfileItemBriefFacade) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const {
      params: { profileId },
    } = route;
    return checkStoreState(this.failedMessagesProfileItemBriefFacade, profileId);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.failedMessagesProfileItemBriefFacade);
  }
}
